"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var psdWriter_1 = require("./psdWriter");

var psdReader_1 = require("./psdReader");

var helpers_1 = require("./helpers");

exports.initializeCanvas = helpers_1.initializeCanvas;

var psd_1 = require("./psd");

exports.ColorMode = psd_1.ColorMode;
exports.ChannelID = psd_1.ChannelID;
exports.Compression = psd_1.Compression;
exports.SectionDividerType = psd_1.SectionDividerType;

var base64_js_1 = require("base64-js");

exports.byteArrayToBase64 = base64_js_1.fromByteArray;

function readPsd(buffer, options) {
  var reader = 'buffer' in buffer ? psdReader_1.createReader(buffer.buffer, buffer.byteOffset, buffer.byteLength) : psdReader_1.createReader(buffer);
  return psdReader_1.readPsd(reader, options);
}

exports.readPsd = readPsd;

function writePsd(psd, options) {
  var writer = psdWriter_1.createWriter();
  psdWriter_1.writePsd(writer, psd, options);
  return psdWriter_1.getWriterBuffer(writer);
}

exports.writePsd = writePsd;

function writePsdBuffer(psd, options) {
  if (typeof Buffer === 'undefined') {
    throw new Error('Buffer not supported on this platform');
  }

  return Buffer.from(writePsd(psd, options));
}

exports.writePsdBuffer = writePsdBuffer;